// src/presentation/pages/ClinicalExamination/Step5Screening.tsx
import React from "react";

import type { ScreeningFormData } from "./types";
import { Separator } from "@/components/ui/separator";
import { useTranslation } from "react-i18next";
import {
  RecommendedDoctorsSection,
  ScreeningRequiredSection,
} from "./sections";

interface Step5ScreeningProps {
  formData: ScreeningFormData;
  onFormDataChange: (data: ScreeningFormData) => void;
  patientId: string;
  assessmentId?: string;
}

const Step5Screening: React.FC<Step5ScreeningProps> = ({
  formData,
  onFormDataChange,
  patientId,
  assessmentId,
}) => {
  const { t } = useTranslation("patients");
  const updateFormData = (updates: Partial<ScreeningFormData>) => {
    onFormDataChange({ ...formData, ...updates });
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col">
        <p className="text-[#5F646F] text-sm"> {t("clinicalSections.step5.stepLabel")}</p>
        <div className="flex gap-2 items-center">
          <h3 className="text-lg font-bold text-gray-900">
            {t("clinicalSections.step5.title")}
          </h3>
          <div className="bg-[#D4DAEB] p-2 rounded">
            <p className="">{t("clinicalSections.step5.answeredByDoctor")}</p>
          </div>
        </div>
      </div>

      <ScreeningRequiredSection
        isScreeningRequired={formData.isScreeningRequired}
        onChange={(value) => updateFormData({ isScreeningRequired: value })}
      />
      <Separator />
      <RecommendedDoctorsSection
        patientId={patientId}
        assessmentId={assessmentId}
        selectedDoctors={formData.selectedDoctors}
        onDoctorsChange={(ids) => updateFormData({ selectedDoctors: ids })}
      />
    </div>
  );
};

export default Step5Screening;
